import { gastoApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'GASTO',
    api: gastoApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'GASTO',
  api: gastoApi,
  relUrl: '',
});

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'GASTO',
    api: gastoApi,
    relUrl: `indexByParent/${id}`,
  });

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'GASTO',
    api: gastoApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'GASTO',
    api: gastoApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'GASTO',
  api: gastoApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'GASTO',
    api: gastoApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('GASTO');
export const setDeletedPending = createListDataDeletedPending('GASTO');
